var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[(_vm.showHeader)?_c('v-col',{staticClass:"col-12"},[_c('top-nav')],1):_vm._e()],1)],1),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }